<template>
    <v-card
            color="grey darken-2"
            @mouseover="editButtonVisible=true"
            @mouseout="editButtonVisible=false"
            :class="editButtonVisible? 'elevation-10' : 'elevation-2'"
    >
        <v-card-title class="title primary pt-2">
            <v-icon class="pr-2" medium>{{icon}}</v-icon>
            {{title}}
        </v-card-title>
        <v-card-text class="pb-0 pt-3">
            <div class="description overflow-hidden">
                {{description}}
            </div>
        </v-card-text>
        <v-card-actions>
            <v-switch color="primary" ripple class="pl-2" v-model="model" label="Enabled"></v-switch>
        </v-card-actions>

        <v-fab-transition>
            <v-btn v-show="editButtonVisible"
                   color="primary"
                   dark
                   small
                   absolute
                   bottom
                   right
                   fab
                   style="margin-bottom: 35px"
                   @click="editClicked()"
            >
                <v-tooltip top color="primary">
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on">mdi-pencil</v-icon>
                    </template>
                    <span>Edit properties</span>
                </v-tooltip>
            </v-btn>
        </v-fab-transition>

    </v-card>

</template>

<script>
    export default {

        components: {},

        props: {
            'title': {
                type: String,
                required: true,
            },

            'icon': {
                type: String,
                required: false,
                default: 'mdi-star'
            },

            'description': {
                type: String,
                required: true,
            },

            'enabled': {
                type: Boolean,
                required: true,
                default: false,
            }
        },

        data() {
            return {
                model: true,
                editButtonVisible: false
            }
        },

        mounted() {
            this.model = this.enabled;
        },

        methods: {
            editClicked() {
                Bus.$emit('flash-message', {message: 'Editing is not possible in demo mode!'});
            }
        }
    }
</script>

<style scoped>
    .description {
        height: 45px;
    }
</style>
